import { useEffect } from "react";

/** Lock scroll + ESC while a full-page preview overlay is open. Restores previous overflow on close. */
export function usePreviewModalChrome(onClose) {
  useEffect(() => {
    if (!onClose) return undefined;
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      e.preventDefault();
      e.stopPropagation();
      onClose?.();
    };
    window.addEventListener("keydown", onKey, true);
    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
      window.removeEventListener("keydown", onKey, true);
    };
  }, [onClose]);
}
